// eslint-disable-next-line no-unused-vars
export var ConversationStatusType;
(function (ConversationStatusType) {
    ConversationStatusType["OPEN"] = "OPEN";
    ConversationStatusType["CLOSED"] = "CLOSED";
})(ConversationStatusType || (ConversationStatusType = {}));
export var ConversationMediaType;
(function (ConversationMediaType) {
    ConversationMediaType["IMAGE"] = "IMAGE";
    ConversationMediaType["VIDEO"] = "VIDEO";
    ConversationMediaType["SOUND"] = "SOUND";
    ConversationMediaType["FILE"] = "FILE";
})(ConversationMediaType || (ConversationMediaType = {}));
export var ConversationItemTypeEnum;
(function (ConversationItemTypeEnum) {
    ConversationItemTypeEnum["MESSAGE"] = "MESSAGE";
    ConversationItemTypeEnum["INPUT_FIELD"] = "INPUT";
    ConversationItemTypeEnum["FORM"] = "FORM";
    ConversationItemTypeEnum["CHAT_CLOSED"] = "CHAT-CLOSED";
})(ConversationItemTypeEnum || (ConversationItemTypeEnum = {}));
export var MessageInboundState;
(function (MessageInboundState) {
    MessageInboundState["RECEIVED"] = "RECEIVED";
    MessageInboundState["TYPING"] = "TYPING";
    MessageInboundState["READ"] = "READ";
})(MessageInboundState || (MessageInboundState = {}));
export var MessageOutboundState;
(function (MessageOutboundState) {
    MessageOutboundState["DRAFT"] = "DRAFT";
    MessageOutboundState["SENDING"] = "SENDING";
    MessageOutboundState["SENT"] = "SENT";
    MessageOutboundState["SENT_FAILURE"] = "SENT-FAILURE";
    MessageOutboundState["READ"] = "READ"; // not implemented atm
})(MessageOutboundState || (MessageOutboundState = {}));
export var ConversationFormType;
(function (ConversationFormType) {
    ConversationFormType["PRECHAT"] = "PRECHAT";
    ConversationFormType["CUSTOM"] = "CUSTOM";
})(ConversationFormType || (ConversationFormType = {}));
export var ConversationInputFieldType;
(function (ConversationInputFieldType) {
    ConversationInputFieldType["EMAIL"] = "EMAIL";
})(ConversationInputFieldType || (ConversationInputFieldType = {}));
export var ContactChannels;
(function (ContactChannels) {
    ContactChannels["EMAIL"] = "EMAIL";
    ContactChannels["WHATSAPP"] = "WHATSAPP";
})(ContactChannels || (ContactChannels = {}));
